import { store } from 'src/redux';

export const hasEditAccess = (user, privilege) => {
	const MODULE_CODE_KEYS = store.getState().user.accesslist;
	return user?.user_role?.some((role) =>
		MODULE_CODE_KEYS[role]?.some(
			(module) =>
				module.key === privilege.toLowerCase() && module.access === 'edit'
		)
	);
};
